import { gql } from '@apollo/client';

/**
 * Keystone's staff surface: who is admitted to the platform tenant, and the
 * platform roles each holds. Reading it is `internal_accounts` Read; every
 * write is Full. Keystone keeps no email, so an account names its Turnstile
 * person rather than an address.
 */

export type PlatformRole = 'ADMIN' | 'ACCOUNT_MANAGER' | 'PRODUCT_ENGINEER' | 'PLATFORM_ENGINEER';

export interface InternalAccount {
  id: string;
  personId: string | null;
  extTurnstileId: string | null;
  roles: PlatformRole[];
  createdAt: string | null;
}

const ACCOUNT_FIELDS = `
  id
  personId
  extTurnstileId
  roles
  createdAt
`;

export const INTERNAL_ACCOUNTS_QUERY = gql`
  query InternalAccounts {
    internalAccounts {
      ${ACCOUNT_FIELDS}
    }
  }
`;

export interface InternalAccountsResult {
  internalAccounts: InternalAccount[];
}

export const ADMIT_STAFF = gql`
  mutation AdmitStaff($email: String!, $roles: [PlatformRole!]!) {
    admitStaff(email: $email, roles: $roles) {
      ${ACCOUNT_FIELDS}
    }
  }
`;

export const ASSIGN_PLATFORM_ROLE = gql`
  mutation AssignPlatformRole($personId: UUID!, $role: PlatformRole!) {
    assignPlatformRole(personId: $personId, role: $role) {
      ${ACCOUNT_FIELDS}
    }
  }
`;

export const UNASSIGN_PLATFORM_ROLE = gql`
  mutation UnassignPlatformRole($personId: UUID!, $role: PlatformRole!) {
    unassignPlatformRole(personId: $personId, role: $role) {
      ${ACCOUNT_FIELDS}
    }
  }
`;

export const REMOVE_STAFF = gql`
  mutation RemoveStaff($personId: UUID!) {
    removeStaff(personId: $personId)
  }
`;
